module.exports = __webpack_public_path__ + "img/bookmark.4a4a73.svg";